import { createElement } from '@syncfusion/ej2-base';
import { DateTimePicker } from '@syncfusion/ej2-calendars';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');





export function corEvent(args: any) {
  if (args.data.EventType === 'public-event') {
    let date = moment(args.data.EventTypeDate);
    let now = moment();
    if (date < now) {
      args.element.style.backgroundColor = '#8d0202';
    } else {
      args.element.style.backgroundColor = '#1E8F76';
    }
  } else {
    args.element.style.backgroundColor = '#3167D2';
  }
}



export function sendEmail(args: any) {
  if (args.type === 'QuickInfo') {
    if (args.data.EventType === 'public-event') {
      let row = createElement('div', { className: 'custom-field-row' });
      let formElement = args.element.querySelector('.e-popup-content');

      formElement.prepend(row, formElement.firstChild);
      let container = createElement('div', {
        className: 'custom-field-container-email',
      });
      let inputEle = createElement('div');
      container.appendChild(inputEle);
      row.appendChild(container);

      let date = moment(args.data.EventTypeDate).format('LLL');
      if (moment(args.data.EventTypeDate) < moment()) {
        inputEle.innerHTML = `
              <div
              class="custom-field-label"
              style="
                font-size: 14px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-top: 10px; 
              "
            >
              <div style="width: 22px; heigth: 22px; margin-right: 13px;">
                <svg role="img" fill="#888" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <title>Minutemailer</title>
                  <path
                    d="M17.187 19.181L24 4.755 0 12.386l9.196 1.963.043 4.896 2.759-2.617-2.147-2.076 7.336 4.63z"
                  />
                </svg>
              </div>
              Email enviado ${date}
            </div>
          `;
      } else {
        inputEle.innerHTML = `
              <div
              class="custom-field-label"
              style="
                font-size: 14px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-top: 10px; 
              "
            >
              <div style="width: 22px; heigth: 22px; margin-right: 13px;">
                <svg role="img" fill="#888" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <title>Minutemailer</title>
                  <path
                    d="M17.187 19.181L24 4.755 0 12.386l9.196 1.963.043 4.896 2.759-2.617-2.147-2.076 7.336 4.63z"
                  />
                </svg>
              </div>
              Enviar email ${date}
            </div>
          `;
      }
    }
  }

  if (args.type === 'Editor') {
    if (!args.element.querySelector('.custom-field-row')) {
      let row = createElement('div', { className: 'custom-field-row' });
      let formElement = args.element.querySelector('.e-schedule-form');
      formElement.firstChild.insertBefore(
        row,
        formElement.firstChild.firstChild
      );
      let containerDrop = createElement('div', {
        className: 'custom-field-container-drop',
      });

      let container = createElement('div', {
        className: 'custom-field-container',
      });
      let inputEle = createElement('input', {
        className: 'e-field input-filed-custom',
        attrs: { name: 'EventType' },
      });

      let dropdownEle = createElement('input', {
        className: 'e-field',
        attrs: { name: 'EventTypeDate' },
      });

      container.appendChild(inputEle);
      row.appendChild(container);
      containerDrop.appendChild(dropdownEle);
      row.appendChild(containerDrop);

      let dateTimePicker = new DateTimePicker({
        format: 'dd-MM-yyyy HH:mm',
        timeFormat: 'HH:mm',
        placeholder: 'Escolha o dia de envio',
        floatLabelType: 'Always',
        value: args.data.EventTypeDate,
      });
      let drowDownList = new DropDownList({
        dataSource: [
          { text: 'Sim', value: 'public-event' },
          { text: 'Não', value: 'private-event' },
        ],
        fields: { text: 'text', value: 'value' },
        value: args.data.EventType as string,
        floatLabelType: 'Always',
        placeholder: 'Enviar email para os membros?',
      });

      dateTimePicker.appendTo(dropdownEle);
      drowDownList.appendTo(inputEle);

      dropdownEle.setAttribute('name', 'EventTypeDate');
      inputEle.setAttribute('name', 'EventType');
    }
  }
}